/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getGlobalVocabulary = /* GraphQL */ `
  query GetGlobalVocabulary($id: ID!) {
    getGlobalVocabulary(id: $id) {
      id
      word
      translation
      textToSpeech
      wordImage
      setName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGlobalVocabularies = /* GraphQL */ `
  query ListGlobalVocabularies(
    $filter: ModelGlobalVocabularyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGlobalVocabularies(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        word
        translation
        textToSpeech
        wordImage
        setName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const wordsByWord = /* GraphQL */ `
  query WordsByWord(
    $word: String!
    $sortDirection: ModelSortDirection
    $filter: ModelGlobalVocabularyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    wordsByWord(
      word: $word
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        word
        translation
        textToSpeech
        wordImage
        setName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const wordsByTranslation = /* GraphQL */ `
  query WordsByTranslation(
    $translation: String!
    $sortDirection: ModelSortDirection
    $filter: ModelGlobalVocabularyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    wordsByTranslation(
      translation: $translation
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        word
        translation
        textToSpeech
        wordImage
        setName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const wordsBySetName = /* GraphQL */ `
  query WordsBySetName(
    $setName: String!
    $sortDirection: ModelSortDirection
    $filter: ModelGlobalVocabularyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    wordsBySetName(
      setName: $setName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        word
        translation
        textToSpeech
        wordImage
        setName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserVocabulary = /* GraphQL */ `
  query GetUserVocabulary($id: ID!) {
    getUserVocabulary(id: $id) {
      id
      owner
      word
      translation
      progress
      setName
      isHidden
      wordImage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserVocabularies = /* GraphQL */ `
  query ListUserVocabularies(
    $filter: ModelUserVocabularyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserVocabularies(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        word
        translation
        progress
        setName
        isHidden
        wordImage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const vocabByOwner = /* GraphQL */ `
  query VocabByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserVocabularyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vocabByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        word
        translation
        progress
        setName
        isHidden
        wordImage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userWordsByWord = /* GraphQL */ `
  query UserWordsByWord(
    $word: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserVocabularyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userWordsByWord(
      word: $word
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        word
        translation
        progress
        setName
        isHidden
        wordImage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userWordsByTranslation = /* GraphQL */ `
  query UserWordsByTranslation(
    $translation: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserVocabularyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userWordsByTranslation(
      translation: $translation
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        word
        translation
        progress
        setName
        isHidden
        wordImage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userWordsBySetName = /* GraphQL */ `
  query UserWordsBySetName(
    $setName: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserVocabularyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userWordsBySetName(
      setName: $setName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        word
        translation
        progress
        setName
        isHidden
        wordImage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSets = /* GraphQL */ `
  query GetSets($id: ID!) {
    getSets(id: $id) {
      id
      setName
      setImage
      numberOfWords
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSets = /* GraphQL */ `
  query ListSets(
    $filter: ModelSetsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        setName
        setImage
        numberOfWords
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const setByName = /* GraphQL */ `
  query SetByName(
    $setName: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSetsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    setByName(
      setName: $setName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        setName
        setImage
        numberOfWords
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSentences = /* GraphQL */ `
  query GetSentences($id: ID!) {
    getSentences(id: $id) {
      id
      createdAt
      updatedAt
      sentence
      translation
      number
      topic
      __typename
    }
  }
`;
export const listSentences = /* GraphQL */ `
  query ListSentences(
    $filter: ModelSentencesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSentences(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        sentence
        translation
        number
        topic
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sentenceByNumber = /* GraphQL */ `
  query SentenceByNumber(
    $number: Int!
    $sortDirection: ModelSortDirection
    $filter: ModelSentencesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sentenceByNumber(
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        sentence
        translation
        number
        topic
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sentenceByTopic = /* GraphQL */ `
  query SentenceByTopic(
    $topic: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSentencesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sentenceByTopic(
      topic: $topic
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        sentence
        translation
        number
        topic
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getArticles = /* GraphQL */ `
  query GetArticles($id: ID!) {
    getArticles(id: $id) {
      id
      createdAt
      updatedAt
      articleName
      articleText
      isRead
      category
      __typename
    }
  }
`;
export const listArticles = /* GraphQL */ `
  query ListArticles(
    $filter: ModelArticlesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        articleName
        articleText
        isRead
        category
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const articleByName = /* GraphQL */ `
  query ArticleByName(
    $articleName: String!
    $sortDirection: ModelSortDirection
    $filter: ModelArticlesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    articleByName(
      articleName: $articleName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        articleName
        articleText
        isRead
        category
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const articleByCategory = /* GraphQL */ `
  query ArticleByCategory(
    $category: String!
    $sortDirection: ModelSortDirection
    $filter: ModelArticlesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    articleByCategory(
      category: $category
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        articleName
        articleText
        isRead
        category
        __typename
      }
      nextToken
      __typename
    }
  }
`;
